import { useGantt } from "../../../hooks/useGantt";
import CircularProgressBar from "./CircularBar";

import {
  Container,
  TableContainer,
  Title,
  THColaborador,
  THConcluidas,
  THAtrasadas,
  THPendentes,
  THProdutividade,
  Table,
  TRLine,
  TBColaborador,
  TBConcluidas,
  TBAtrasadas,
  TBPendentes,
  TBProdutividade,
  Avatar,
} from "./styles";

const GetProductivity = (jobs) => {
  const filteredList = jobs.filter((obj) => obj.type === "task");

  const totalProduction = {
    accountable: {
      username: "Geral",
      userId: "totalProduction",
      avatarURL:
        "data:image/png;base64,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",
    },
    done: 0,
    doneLate: 0,
    pending: 0,
    totalHoursToFinish: 0,
    totalExpectedHours: 0,
  };

  const groupedData = filteredList.reduce((acc, obj) => {
    const { accountable, status, duration, start, end } = obj;
    const accountId = accountable?.userId;
    const startTime = new Date(start);
    const endTime = new Date(end);
    let hoursToFinish = (endTime - startTime) / (1000 * 60 * 60);
    hoursToFinish = Math.max(hoursToFinish, 1);

    if (!acc[accountId]) {
      acc[accountId] = {
        accountable: accountable,
        done: 0,
        doneLate: 0,
        pending: 0,
        totalHoursToFinish: 0,
        totalExpectedHours: 0,
      };
    }

    acc[accountId][status]++;
    if (status === "done" || status === "doneLate") {
      acc[accountId].totalHoursToFinish += hoursToFinish;
      acc[accountId].totalExpectedHours += duration.number;
    }

    // Update the totalProduction data
    totalProduction[status]++;
    if (status === "done" || status === "doneLate") {
      totalProduction.totalHoursToFinish += hoursToFinish;
      totalProduction.totalExpectedHours += duration.number;
    }

    return acc;
  }, {});

  const orderedData = {
    totalProduction: totalProduction,
    ...groupedData,
  };

  return orderedData;
};

const ProductivityList = ({ tableRef }) => {
  const { jobs } = useGantt();
  const productivity = GetProductivity(jobs);
  return (
    <Container ref={tableRef}>
      <Title>Resumo de Produtividade</Title>
      <TableContainer>
        <Table>
          <thead>
            <tr>
              <THColaborador>Colaborador</THColaborador>
              <THConcluidas>Concluídas</THConcluidas>
              <THAtrasadas>Atrasadas</THAtrasadas>
              <THPendentes>Pendentes</THPendentes>
              <THProdutividade>Produtividade</THProdutividade>
            </tr>
          </thead>
          <tbody>
            {Object.keys(productivity).map((accountId) => {
              const item = productivity[accountId];
              return (
                <TRLine key={accountId}>
                  <TBColaborador>
                    <Avatar
                      src={
                        item.accountable?.avatarURL
                          ? item.accountable?.avatarURL
                          : "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAADsAAAA7AF5KHG9AAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAllJREFUWIXFlr9PVEEQxz/e6VkcnLGVxhilEBLkD5BCBDujxNz/IAERS0OPWNhoLLQ1SEIsbYmKNEYbOeP5s9EYNWhCsJEEsNjZvL3N7r7H7lO/yeYlM9/Z+b6dnXkPdoca0ATmgTbwS1ZbbE3h/BWMAR+AnZz1HjhfZuIKcN1IsApMAX1AXVaf2FYN3pzEJkMn/w2M52xaBSaEq0UkYcxIfsqwN4DbwBdgDVgAegz/sCHiXGzyGlnNxw17BVjBXfuGwZsU+ztgX4yAJlnNq4Z9SOwfgWPAYeCl2C4avCrQEvuFGAH3JfiSZd8PXAUGDNtl4d6wuNNivxcj4I0EH8/h1YHHwp2wfP1ib8cI2JDgrgDnCKr2O8An4KDl7xbfRoqA7gDnoXBeoO6DjYb412MEFCnBmnAOefy5JQgNlefyHA1wWiihXz3+M/J8FtjDC92GLTrb0IbvJarAKxLasEZ2wezbrbECLHt8UxL7lshBBOqrpkfxsMO/DDxx2E8Dm8A2cDY2ucacIWKScDn2ot58U2JmU5ODqrEWoe/ENOqGd8nqB66Q1XwbuEZJn+MR4C7wGdgyhPjWFmoo3UGVIhq9ZCM2ZT3CPaSCGAJ+ygbfgBngBGru56EODErMd9njB3CyaPJeI/ki4VGchwbwwBBxtEiQPvZFYE9Cco2KIWIpjzxCduwpb27jAFk5OuaJ3SZNed4k8hPqwTpwy8rhRBulcsCyh0auCy7+oOz9OhTo+wnRLVUULn6hnxNfojIEOO2ljMoU/HcBdp/v5phLyWufwNN/kLyjO/4AEWrQwym30uMAAAAASUVORK5CYII="
                      }
                    />
                    {item.accountable?.username
                      ? item.accountable?.username?.split(" ")[0]
                      : " - - - "}
                  </TBColaborador>
                  <TBConcluidas>{item.done}</TBConcluidas>
                  <TBAtrasadas>{item.doneLate}</TBAtrasadas>
                  <TBPendentes>{item.pending}</TBPendentes>
                  <TBProdutividade>
                    <CircularProgressBar
                      productivity={
                        item.totalHoursToFinish === 0
                          ? 0
                          : Math.min(
                              Math.floor(
                                (1 /
                                  (item.totalHoursToFinish /
                                    item.totalExpectedHours)) *
                                  100,
                              ),
                              999,
                            )
                      }
                    />
                  </TBProdutividade>
                </TRLine>
              );
            })}
          </tbody>
        </Table>
      </TableContainer>
    </Container>
  );
};

export default ProductivityList;
